import React, { useEffect, useState } from 'react';
import './App.css';
import { SignInButton } from './components/SignInButton';
import { SignOutButton } from './components/SignOutButton';
import { useIsAuthenticated } from '@azure/msal-react';
import { io, Socket } from 'socket.io-client';
import HelloService from './services/HelloService';
import { useService } from './hooks/useService';

const App: React.FC = () => {
  const isAuthenticated = useIsAuthenticated();
  const helloService = useService(HelloService);
  const [backendMessage, setBackendMessage] = useState<string>('');
  const [messages, setMessages] = useState<string[]>([]);
  const [socket, setSocket] = useState<Socket | null>(null);

  useEffect(() => {
    if (isAuthenticated && helloService) {
      helloService.hello().then(setBackendMessage).catch(console.error);
    }
  }, [isAuthenticated, helloService]);

  useEffect(() => {
    const s = io(process.env.REACT_APP_BACKEND_URL as string);
    s.on('message', msg => setMessages(prev => [...prev, msg]));
    setSocket(s);
    return () => { s.disconnect(); };
  }, []);

  const sendMessage = () => {
    socket?.emit('message', 'Hello from the frontend!');
  };

  return (
    <div className="App">
      <h1>Hello World Template</h1>
      {isAuthenticated ? <SignOutButton /> : <SignInButton />}
      {isAuthenticated && (
        <div>
          <p>{backendMessage}</p>
          <button onClick={sendMessage}>Send Socket Message</button>
          <ul>
            {messages.map((m, i) => (
              <li key={i}>{m}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default App;
